import React, { useState } from "react";
import { Link } from "react-router-dom";
import authService from "../../services/authService";
import { showToast } from "../../utils/showToast";
import "../../styles/dashboardTheme.css";

const extractTokenFromLink = (link) => {
  if (!link) return "";
  try {
    const url = new URL(link);
    const segments = url.pathname.split("/").filter(Boolean);
    return segments.pop() || "";
  } catch (error) {
    const segments = link.split("/").filter(Boolean);
    return segments.pop() || "";
  }
};

export default function RequestPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) {
      showToast({ type: "warning", message: "Ingrese su correo electrónico" });
      return;
    }

    setLoading(true);

    try {
      const data = await authService.forgotPassword(email);
      const tokenFromLink = extractTokenFromLink(data.resetLink);
      const recoveryLink = tokenFromLink ? `/reset-password/${tokenFromLink}` : data.resetLink || "";
      showToast({
        type: "success",
        message: data.message || "Hemos enviado instrucciones a su correo",
        actions: recoveryLink
          ? (dismiss) => (
              <a
                href={recoveryLink}
                className="btn btn-sm text-white"
                target="_blank"
                rel="noreferrer"
                onClick={() => dismiss()}
              >
                Abrir enlace
              </a>
            )
          : null,
      });
    } catch (error) {
      const msg = error?.data?.message || error.message || "Error de conexión con el servidor";
      showToast({ type: "danger", message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="text-center mb-4">
          <span className="dashboard-eyebrow d-inline-block mb-1">Soporte</span>
          <h2 className="auth-title mb-2">Recuperar contraseña</h2>
          <p className="auth-subtitle">Ingrese su correo registrado para recibir el enlace</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="auth-form-group">
            <label htmlFor="email" className="form-label dashboard-label">Correo electrónico</label>
            <input
              type="email"
              id="email"
              className="form-control auth-input"
              placeholder="ejemplo@correo.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
          </div>

          <button type="submit" className="btn dashboard-btn-primary w-100" disabled={loading}>
            {loading ? "Enviando..." : "Enviar enlace"}
          </button>
        </form>

        <div className="auth-extra">
          <Link to="/" className="auth-link">Volver al inicio de sesión</Link>
        </div>
      </div>
    </div>
  );
}
